/**
 * An address that names no restaurant (owner, 2026-10-04: a login exists only
 * on a restaurant's own address; 2026-10-05: the bare domain shows
 * RestoBOXX's own landing page, pages/RestoLanding.jsx).
 *
 * Same names as the server's bare_domain_signin_refusal
 * (backend/restoboxx/tenant_middleware.py): the two product domains and their
 * www/api/admin. The Windows POS and the Android till reach the server by its
 * LAN address, which is none of these, and keep their login.
 */
const ROOT_DOMAINS = ['restoboxx.com', 'restoboxx.prosoft.mu'];
const NOT_RESTAURANTS = ['www', 'api', 'admin'];

export function isBareDomain(host = typeof window === 'undefined' ? '' : window.location.hostname) {
  const h = host.toLowerCase();
  return ROOT_DOMAINS.some((dom) => h === dom || NOT_RESTAURANTS.some((label) => h === `${label}.${dom}`));
}
